interface FullPageSkeletonProps {
  title?: string
  message?: string
}

export function FullPageSkeleton({ title, message }: FullPageSkeletonProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-earth-50">
      <div className="max-w-xl w-full px-6">
        <div className="bg-adventure-50 border border-adventure-200 rounded-lg p-6 space-y-4 animate-pulse">
          <div className="h-6 bg-adventure-200 rounded w-1/3" />
          <div className="h-4 bg-adventure-100 rounded w-2/3" />
          <div className="space-y-2 pt-2">
            <div className="h-3 bg-adventure-100 rounded w-full" />
            <div className="h-3 bg-adventure-100 rounded w-5/6" />
            <div className="h-3 bg-adventure-100 rounded w-2/3" />
          </div>
        </div>

        {(title || message) && (
          <div className="mt-4 text-center space-y-1">
            {title && <p className="text-sm font-medium text-foreground">{title}</p>}
            {message && <p className="text-xs text-muted-foreground">{message}</p>}
          </div>
        )}
      </div>
    </div>
  )
}

